import { render, staticRenderFns } from "./betbuilder.vue?vue&type=template&id=b6c4cf44&scoped=true&"
import script from "./betbuilder.vue?vue&type=script&lang=js&"
export * from "./betbuilder.vue?vue&type=script&lang=js&"
import style0 from "./betbuilder.vue?vue&type=style&index=0&id=b6c4cf44&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b6c4cf44",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {SuperbannerBetbuilderSlide: require('/var/web/bet777.es/components/superbanner/betbuilder_slide.vue').default})
